
function baseConfig(baseApi) {
    const config={
        probateAPIURL: `${baseApi}/ProbateAPI/api/1.0`,
        baseurl: baseApi,
        version: "1.0.0",
        lastAccessTime: new Date().toLocaleDateString(),
        docAssembleURL: `${baseApi}/web-da/docassemble`,
        updateProfileURL: `${baseApi}/UserProfile/EditSingPassProfile`,
        isProduction: false,
        isDevelopment: false,
        isUAT: false,
        Features: {
            R3Rule: {
                isPreR3Rule: false,
                isPostR3Rule: true, // this flag must be invert with isPreR3Rule flag. 
                EffectiveStartDate: "12 Jun 2024",
                RuleName: "R3",
                JudiciaryUrl: "https://www.judiciary.gov.sg/family/apply-for-probate"
            }, 
            TieredRejectionFee: {
                isEnabled: true, // this flag must be parallel with isPostR3Rule flag.
            }
        }
    };
    return config;
}
export default baseConfig;